export default __webpack_public_path__ + "static/media/empty_profile.ad39df0f.png";